"use client";

/**
 * React context for the active template theme. Split from templateVariables.ts
 * so that module stays pure (no React) and server code can resolve template
 * variables — the native menu experience route does.
 */

import { createContext, useContext } from "react";

import type { TemplateThemeContextValue } from "./templateVariables";

export const TemplateThemeContext = createContext<TemplateThemeContextValue | null>(null);

/**
 * Hook for external components to consume the active template theme.
 * Must be used inside a TemplateThemeProvider (rendered by TemplateRenderer
 * or PagedFlipRenderer).
 *
 * Returns null when used outside a provider (e.g. in a story or test) ,
 * always guard with a null check or provide a fallback.
 */
export function useTemplateTheme(): TemplateThemeContextValue | null {
  return useContext(TemplateThemeContext);
}
